// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* :root {
  --size: 54px;
  --speed:2s;
} */


.custom-title-button {
  transition: all 0.5s ease-in-out !important;
}
.think-ai {
  transition: all 0.5s ease-in-out !important;
  transform: translate(-50%, 50%) !important;
  left: 50%;
  bottom: 50%;
  z-index: 99;
  font-size: 100px;
}

.inactive-result {
  /* filter: blur(0.9px); */
  opacity: 0.5;
}

.idea-item{
  transition: all 0.5s ease-in-out !important;
}

.yes-results {
  position: sticky !important;
  transform: translate(0) !important;
  bottom: 20px;
  /* margin-left: 20px; */
  font-size: 50px;
  justify-content: flex-start;
}

/* .yes-results loader, .yes-results .loader__inner {
  width: 50px;
  height: 50px;
} */


/* Results Style  */
.result-item,
.result-item .bullet,
.result-item .text {
  transition: all 0.3s ease-in-out !important;
}

.result-item:hover {
  transform: translateY(-5px);
  background-color: var(--bs-primary-light) !important;
}

.result-item:hover > .bullet {
  background-color: var(--bs-primary) !important;
}

.result-item:hover .text {
  color: var(--bs-text-primary) !important;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/shared/partials/ai/ai-idea-generator/ai-idea-generator.component.css"],"names":[],"mappings":"AAAA;;;GAGG;;;AAGH;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,SAAS;EACT,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;;GAGG;;;AAGH,mBAAmB;AACnB;;;EAGE,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,owEAAowE","sourcesContent":["/* :root {\n  --size: 54px;\n  --speed:2s;\n} */\n\n\n.custom-title-button {\n  transition: all 0.5s ease-in-out !important;\n}\n.think-ai {\n  transition: all 0.5s ease-in-out !important;\n  transform: translate(-50%, 50%) !important;\n  left: 50%;\n  bottom: 50%;\n  z-index: 99;\n  font-size: 100px;\n}\n\n.inactive-result {\n  /* filter: blur(0.9px); */\n  opacity: 0.5;\n}\n\n.idea-item{\n  transition: all 0.5s ease-in-out !important;\n}\n\n.yes-results {\n  position: sticky !important;\n  transform: translate(0) !important;\n  bottom: 20px;\n  /* margin-left: 20px; */\n  font-size: 50px;\n  justify-content: flex-start;\n}\n\n/* .yes-results loader, .yes-results .loader__inner {\n  width: 50px;\n  height: 50px;\n} */\n\n\n/* Results Style  */\n.result-item,\n.result-item .bullet,\n.result-item .text {\n  transition: all 0.3s ease-in-out !important;\n}\n\n.result-item:hover {\n  transform: translateY(-5px);\n  background-color: var(--bs-primary-light) !important;\n}\n\n.result-item:hover > .bullet {\n  background-color: var(--bs-primary) !important;\n}\n\n.result-item:hover .text {\n  color: var(--bs-text-primary) !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
